import React from 'react';
import { Calendar } from 'antd';

import Header from './Header';
import styles from './styles.module.scss';

export const CalendarRender = ({ dateCellRender, date, onChange }) => (
  <React.Fragment>
    <Header
      date={date}
      onChange={onChange}
    />
    <Calendar
      className={styles.calendar}
      dateCellRender={dateCellRender}
      value={date}
    />
  </React.Fragment>
);

export default CalendarRender;



// WEBPACK FOOTER //
// ./src/components/Agenda/Calendar/CalendarRender.js